import type { EffectDefinition } from './types'
import { rain } from './rain'
import { snow } from './snow'
import { fire } from './fire'
import { matrix } from './matrix'
import { particles } from './particles'
import { fireflies } from './fireflies'
import { smoke } from './smoke'
import { stars } from './stars'
import { glitch } from './glitch'
import { sakura } from './sakura'
import { sparks } from './sparks'
import { plasma } from './plasma'
import { lasers } from './lasers'

export const effects: Record<string, EffectDefinition> = {
  rain,
  snow,
  fire,
  matrix,
  particles,
  fireflies,
  smoke,
  stars,
  glitch,
  sakura,
  sparks,
  plasma,
  lasers
}

export const effectOptions = [
  { label: 'None', value: 'none' },
  { label: 'Rain', value: 'rain' },
  { label: 'Snowfall', value: 'snow' },
  { label: 'Fire', value: 'fire' },
  { label: 'Sakura', value: 'sakura' },
  { label: 'Fireflies', value: 'fireflies' },
  { label: 'Starfield', value: 'stars' },
  { label: 'Smoke', value: 'smoke' },
  { label: 'Floating Particles', value: 'particles' },
  { label: 'Matrix Rain', value: 'matrix' },
  { label: 'Glitch', value: 'glitch' },
  { label: 'Sparks', value: 'sparks' },
  { label: 'Plasma', value: 'plasma' },
  { label: 'Lasers', value: 'lasers' }
]

export function getEffect(id: string): EffectDefinition | undefined {
  return effects[id]
}
